// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.not-found-section ~ * header nav,
.not-found-section ~ * header .mobile-menu-toggle,
body:has(.not-found-section) header nav,
body:has(.not-found-section) header .mobile-menu-toggle {
  display: none !important;
}

.not-found-section {
  height: 86vh;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  overflow: hidden;
}
@media (max-width: 1023px) {
  .not-found-section {
    margin-bottom: 96px;
  }
}
.not-found-section .not-found-left-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.not-found-section .not-found-left-bg::before {
  content: "";
  position: absolute;
  top: 10%;
  left: 120px;
  width: 40%;
  height: 70%;
  background-image: linear-gradient(0deg, rgba(0, 64, 255, 0), #02749F);
  opacity: 0.3;
  filter: blur(50px);
  z-index: -1;
}
.not-found-section .not-found-left-bg img {
  height: 100vh;
  width: auto;
  object-fit: cover;
}
.not-found-section .not-found-right-bg {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.not-found-section .not-found-right-bg::after {
  content: "";
  position: absolute;
  bottom: 10%;
  right: 120px;
  width: 40%;
  height: 70%;
  background-image: linear-gradient(0deg, rgba(0, 255, 60, 0), #1e9f02);
  opacity: 0.2;
  filter: blur(50px);
  z-index: -1;
}
.not-found-section .not-found-right-bg img {
  height: 100vh;
  width: auto;
  object-fit: cover;
}
.not-found-section .container {
  position: relative;
  z-index: 2;
  text-align: center;
}
.not-found-section .not-found-content {
  max-width: 600px;
  margin: 0 auto;
}
.not-found-section .not-found-content .not-found-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 30px;
  line-height: 1;
}
.not-found-section .not-found-content .not-found-title .four-digit {
  font-size: 260px;
  font-weight: 700;
  color: #10366e;
}
@media (max-width: 768px) {
  .not-found-section .not-found-content .not-found-title .four-digit {
    font-size: 120px;
  }
}
@media (max-width: 480px) {
  .not-found-section .not-found-content .not-found-title .four-digit {
    font-size: 80px;
  }
}
.not-found-section .not-found-content .not-found-title .ball-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.not-found-section .not-found-content .not-found-title .ball-icon img {
  width: 200px;
  height: 200px;
  object-fit: contain;
}
@media (max-width: 768px) {
  .not-found-section .not-found-content .not-found-title .ball-icon img {
    width: 120px;
    height: 120px;
  }
}
@media (max-width: 480px) {
  .not-found-section .not-found-content .not-found-title .ball-icon img {
    width: 80px;
    height: 80px;
  }
}
.not-found-section .not-found-content .not-found-text {
  font-size: 18px;
  color: #10366e;
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 768px) {
  .not-found-section .not-found-content .not-found-text {
    font-size: 16px;
    padding: 0 20px;
  }
}
.not-found-section .not-found-content .back-home-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 44px;
  padding: 24px;
  background-image: linear-gradient(6deg, #283E80 28%, #009c50 78%);
  color: white;
  text-decoration: none;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  outline: 2px solid transparent;
  outline-offset: 2px;
  flex: 0 0 auto;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(40, 62, 128, 0.2);
}
.not-found-section .not-found-content .back-home-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.6s ease;
}
.not-found-section .not-found-content .back-home-btn::after {
  content: "→";
  font-size: 18px;
  font-weight: bold;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(0px);
}
.not-found-section .not-found-content .back-home-btn:hover {
  background-image: linear-gradient(6deg, #1e2d5f 28%, #007a3d 78%);
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 8px 20px rgba(40, 62, 128, 0.4);
}
.not-found-section .not-found-content .back-home-btn:hover::before {
  left: 100%;
}
.not-found-section .not-found-content .back-home-btn:hover::after {
  transform: translateX(6px);
}
.not-found-section .not-found-content .back-home-btn:active {
  transform: translateY(-1px) scale(1.01);
  transition-duration: 0.1s;
}
@media (max-width: 480px) {
  .not-found-section .not-found-content .back-home-btn {
    padding: 8px 24px 8px 20px;
    font-size: 14px;
    gap: 8px;
  }
  .not-found-section .not-found-content .back-home-btn::after {
    font-size: 16px;
  }
}
@media (max-width: 1024px) {
  .not-found-section .not-found-left-bg img,
  .not-found-section .not-found-right-bg img {
    height: 100vh;
    width: auto;
  }
}
@media (max-width: 768px) {
  .not-found-section .not-found-left-bg,
  .not-found-section .not-found-right-bg {
    opacity: 0.7;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/notfound/NotFound.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;EAII,wBAAA;AACJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;AAEI;EAVJ;IAWQ,mBAAA;EACN;AACF;AACI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AACR;AACQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,qEAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AACZ;AAGQ;EACI,aAAA;EACA,WAAA;EACA,iBAAA;AADZ;AAKI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AAHR;AAKQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,qEAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAHZ;AAMQ;EACI,aAAA;EACA,WAAA;EACA,iBAAA;AAJZ;AAQI;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;AANR;AASI;EACI,gBAAA;EACA,cAAA;AAPR;AASQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AAPZ;AASY;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;AAPhB;AASgB;EALJ;IAMQ,gBAAA;EANlB;AACF;AAQgB;EATJ;IAUQ,eAAA;EALlB;AACF;AAQY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AANhB;AAQgB;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AANpB;AAQoB;EALJ;IAMQ,YAAA;IACA,aAAA;EALtB;AACF;AAOoB;EAVJ;IAWQ,WAAA;IACA,YAAA;EAJtB;AACF;AASQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAPZ;AASY;EATJ;IAUQ,eAAA;IACA,eAAA;EANd;AACF;AASQ;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,iEAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,4CAAA;AAPZ;AASY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;AAPhB;AAUY;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,0BAAA;AARhB;AAWY;EACI,iEAAA;EACA,uCAAA;EACA,6CAAA;AAThB;AAWgB;EACI,UAAA;AATpB;AAYgB;EACI,0BAAA;AAVpB;AAcY;EACI,uCAAA;EACA,yBAAA;AAZhB;AAeY;EA3DJ;IA4DQ,0BAAA;IACA,eAAA;IACA,QAAA;EAZd;EAcc;IACI,eAAA;EAZlB;AACF;AAiBI;EACI;;IAEI,aAAA;IACA,WAAA;EAfV;AACF;AAkBI;EACI;;IAEI,YAAA;EAhBV;AACF","sourcesContent":["// 404 sayfasında sadece nav ve hamburger menüyü gizle\n.not-found-section ~ * header nav,\n.not-found-section ~ * header .mobile-menu-toggle,\nbody:has(.not-found-section) header nav,\nbody:has(.not-found-section) header .mobile-menu-toggle {\n    display: none !important;\n}\n\n// 404 Not Found Section\n.not-found-section {\n    height: 86vh;\n    width: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: white;\n    overflow: hidden;\n\n    @media (max-width: 1023px) {\n        margin-bottom: 96px;\n    }\n    \n    .not-found-left-bg {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        \n        &::before {\n            content: '';\n            position: absolute;\n            top: 10%;\n            left: 120px;\n            width: 40%;\n            height: 70%;\n            background-image: linear-gradient(0deg, rgba(0, 64, 255, 0), #02749F);\n            opacity: .3;\n            filter: blur(50px);\n            z-index: -1;\n            \n        }\n        \n        img {\n            height: 100vh;\n            width: auto;\n            object-fit: cover;\n        }\n    }\n    \n    .not-found-right-bg {\n        position: absolute;\n        top: 0;\n        right: 0;\n        z-index: 1;\n        \n        &::after {\n            content: '';\n            position: absolute;\n            bottom: 10%;\n            right: 120px;\n            width: 40%;\n            height: 70%;\n            background-image: linear-gradient(0deg, rgba(0, 255, 60, 0), #1e9f02);\n            opacity: .2;\n            filter: blur(50px);\n            z-index: -1;\n        }\n        \n        img {\n            height: 100vh;\n            width: auto;\n            object-fit: cover;\n        }\n    }\n    \n    .container {\n        position: relative;\n        z-index: 2;\n        text-align: center;\n    }\n    \n    .not-found-content {\n        max-width: 600px;\n        margin: 0 auto;\n        \n        .not-found-title {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 10px;\n            margin-bottom: 30px;\n            line-height: 1;\n            \n            .four-digit {\n                font-size: 260px;\n                font-weight: 700;\n                color: #10366e;\n                \n                @media (max-width: 768px) {\n                    font-size: 120px;\n                }\n                \n                @media (max-width: 480px) {\n                    font-size: 80px;\n                }\n            }\n            \n            .ball-icon {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                \n                img {\n                    width: 200px;\n                    height: 200px;\n                    object-fit: contain;\n                    \n                    @media (max-width: 768px) {\n                        width: 120px;\n                        height: 120px;\n                    }\n                    \n                    @media (max-width: 480px) {\n                        width: 80px;\n                        height: 80px;\n                    }\n                }\n            }\n        }\n        \n        .not-found-text {\n            font-size: 18px;\n            color: #10366e;\n            line-height: 1.6;\n            margin-bottom: 40px;\n            max-width: 500px;\n            margin-left: auto;\n            margin-right: auto;\n            \n            @media (max-width: 768px) {\n                font-size: 16px;\n                padding: 0 20px;\n            }\n        }\n        \n        .back-home-btn {\n            display: inline-flex;\n            align-items: center;\n            gap: 12px;\n            height: 44px;\n            padding: 24px;\n            background-image: linear-gradient(6deg, #283E80 28%, #009c50 78%);\n            color: white;\n            text-decoration: none;\n            border-radius: 40px;\n            font-size: 14px;\n            font-weight: 600;\n            cursor: pointer;\n            outline: 2px solid transparent;\n            outline-offset: 2px;\n            flex: 0 0 auto;\n            position: relative;\n            overflow: hidden;\n            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n            box-shadow: 0 2px 8px rgba(40, 62, 128, 0.2);\n            \n            &::before {\n                content: '';\n                position: absolute;\n                top: 0;\n                left: -100%;\n                width: 100%;\n                height: 100%;\n                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n                transition: left 0.6s ease;\n            }\n            \n            &::after {\n                content: '→';\n                font-size: 18px;\n                font-weight: bold;\n                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n                transform: translateX(0px);\n            }\n            \n            &:hover {\n                background-image: linear-gradient(6deg, #1e2d5f 28%, #007a3d 78%);\n                transform: translateY(-3px) scale(1.02);\n                box-shadow: 0 8px 20px rgba(40, 62, 128, 0.4);\n                \n                &::before {\n                    left: 100%;\n                }\n                \n                &::after {\n                    transform: translateX(6px);\n                }\n            }\n            \n            &:active {\n                transform: translateY(-1px) scale(1.01);\n                transition-duration: 0.1s;\n            }\n            \n            @media (max-width: 480px) {\n                padding: 8px 24px 8px 20px;\n                font-size: 14px;\n                gap: 8px;\n                \n                &::after {\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n    \n    @media (max-width: 1024px) {\n        .not-found-left-bg img,\n        .not-found-right-bg img {\n            height: 100vh;\n            width: auto;\n        }\n    }\n    \n    @media (max-width: 768px) {\n        .not-found-left-bg,\n        .not-found-right-bg {\n            opacity: 0.7;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
